import { Button, Snackbar } from "@mui/material";
import { useVersionCheck } from "../Utils/useVersionCheck";
import { Vocabulary } from "../Utils/Vocabulary";
import styles from "./UpdateNotification.module.css";

export default function UpdateNotification() {
  const updateAvailable = useVersionCheck();

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <Snackbar
      open={updateAvailable}
      message={Vocabulary.appErrorTitle}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      className={styles.snackbar}
      action={
        <Button color="primary" variant="contained" size="small" onClick={handleReload}>
          {Vocabulary.appErrorReload}
        </Button>
      }
    />
  );
}
